/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Fit } from '../models/Fit';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class AssetService {

    /**
     * @param url
     * @param width
     * @param height
     * @param fit
     * @param quality
     * @returns string Success
     * @throws ApiError
     */
    public static assetGetResizedImage(
        url?: string,
        width?: number,
        height?: number,
        fit?: Fit,
        quality?: number,
    ): CancelablePromise<string> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/Asset/GetResizedImage',
            query: {
                'url': url,
                'width': width,
                'height': height,
                'fit': fit,
                'quality': quality,
            },
        });
    }

    /**
     * @param estateId
     * @param id
     * @returns any Success
     * @throws ApiError
     */
    public static assetDownloadDocument(
        estateId?: string,
        id?: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/Asset/DownloadDocument',
            query: {
                'estateId': estateId,
                'id': id,
            },
        });
    }

    /**
     * @param id
     * @returns string Success
     * @throws ApiError
     */
    public static assetDownloadSoldImages(
        id?: string,
    ): CancelablePromise<string> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/Asset/DownloadSoldImages',
            query: {
                'id': id,
            },
        });
    }

    /**
     * @param id
     * @param sessionId
     * @returns any Success
     * @throws ApiError
     */
    public static assetDownloadSoldImagesV2(
        id?: string,
        sessionId?: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/Asset/DownloadSoldImagesV2',
            query: {
                'id': id,
                'sessionId': sessionId,
            },
        });
    }

}
